module.exports = __webpack_public_path__ + "static/media/selec-nft-5.d693520e.png";